import { Shark, View } from "shark-mvc";
import { Tab } from "bootstrap";

import ContentPack from "../../models/ContentPack";
import ContentPackPage from "../../models/ContentPackPage";
import ImageContent from "../../models/ImageContent";
import PlaceContent from "../../models/PlaceContent";
import TextContent from "../../models/TextContent";

import templateContent from "./content-pack-detail.html";

import contentFinderComponent from "../../components/contentFinder/contentFinderComponent";
import contentPackListView from "./contentPackListView";
import contentPackManager from "../../controllers/contentPackManager";
import imageContentManager from "../../controllers/imageContentManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import placeContentManager from "../../controllers/placeContentManager";
import textContentManager from "../../controllers/textContentManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class ContentPackDetailView extends View {
	route = "content-pack-detail";

	constructor () {
		super("contentPackDetailView");
		this.setTemplate(templateContent);
	}

	addContentToActivePage (content) {
		const currPage = this.getActivePage();

		if (currPage) {
			currPage.addContent(content);
			Shark.render();
		}
	}
	
	addPage () {
		const title = prompt("Inserisci il titolo della nuova pagina:", `Pagina ${Shark.$store.currContentPack.content.secondaryPages.length + 1}`);

		if (title && title.trim()) {
			const { currContentPack } = Shark.get();

			const newPage = new ContentPackPage({
				pageIndex: Shark.$store.currContentPack.content.secondaryPages.length,
				title,
			});

			currContentPack.content.secondaryPages.push(newPage);
			Shark.render();

			const tab = new Tab(document.querySelector(`#tab_${newPage.pageIndex}`));
			tab.show();
		}
	}
	
	addPageBtn_clickHandler () {
		this.addPage();
	}

	addTabHandlers () {
		const tabEl = document.querySelector(`#myTab`);

		if (tabEl) {
			tabEl.addEventListener("shown.bs.tab", (event) => {
				Shark.set({
					activeSecondaryPageIndex: parseInt(event.target.dataset.pageIndex),
				});

				console.log(Shark.$store);
				console.log(Shark.activePage);
			});
		}
	}

	afterLoad () {
		this.addTabHandlers();
	}

	afterRender () {
		document.querySelectorAll(".draggable").forEach(item => {
			item.addEventListener("dragover", this.ddraggable_dragoverHandler);
			item.addEventListener("dragstart", this.ddraggable_dragstartHandler);
			item.addEventListener("drop", this.ddraggable_dropHandler);
		});
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		// contentFinderComponent.on("content_selected", this.contentFinderComponent_content_selectedHandler);

		Shark.set({
			secondaryPages: [],
			activeSecondaryPageIndex: -1,
		});

		if (!Shark.$store.currContentPack) {
			const urlParams = new URLSearchParams(document.location.search);

			if (urlParams.has("copaguid")) {
				waitBoxComponent.open();

				contentPackManager.getByGuid(urlParams.get("copaguid"))
				.then(getByGuidResult => {
					const currContentPack = new ContentPack(getByGuidResult?.data?.[0]);

					if (currContentPack) {
						Shark.set({
							currContentPack,
						});
						Shark.render();
						this.addTabHandlers();
					}
					waitBoxComponent.close();
				});
			}
		}

	}

	beforeUnload () {
		contentFinderComponent.resetContentFinderSearchField();
		//contentFinderComponent.off("content_selected", this.contentFinderComponent_content_selectedHandler);
	}

	async checkShortCode () {
		const { currContentPack } = Shark.get();

		if (currContentPack) {
			return contentPackManager.checkShortCode(currContentPack.shortCode)
			.then(response => {
				if (response.data.length > 0) {
					const foundContentPack = response.data[0];
					if (foundContentPack.guid !== currContentPack.guid) {
						alert(`Attenzione, il Codice di Link inserito è già usato dal Pacchetto "${foundContentPack.title}", è impossibile usarlo in questo Pacchetto.`);
						return false;
					}
				}

				return true;
			});
		}
	}

	contentFinderComponent_content_selectedHandler (event, data) {
		console.log(this, {event, data});
	
		// Dave: Questa roba sotto è ripetuta in Dashboard
		let contentManager;

		switch (data.contentType) {
			case "image":
				contentManager = imageContentManager;
				break;
			case "place":
				contentManager = placeContentManager;
				break;
			case "text":
				contentManager = textContentManager;
				break;
		}

		contentManager.getByGuid(data.guid)
		.then(getByGuidResponse => {
			console.log({getByGuidResponse});
	
			let currContent;

			switch (data.contentType) {
				case "image":
					currContent = new ImageContent(getByGuidResponse.data[0]);
					break;
				case "place":
					currContent = new PlaceContent(getByGuidResponse.data[0]);
					break;
				case "text":
					currContent = new TextContent(getByGuidResponse.data[0]);
					break;
			}

			contentPackDetailView.addContentToActivePage(currContent);
			contentFinderComponent.resetContentFinderSearchField();
		});
	}

	deleteContentFromActivePage (data) {
		const currPage = this.getActivePage();

		if (currPage) {
			currPage.deleteContent(data);
			Shark.render();
		}
	}

	deleteContentBtn_clickHandler (event, data) {
		// const { currContentPack } = Shark.get();

		if (confirm("Vuoi davvero cancellare questo contenuto?")) {
			this.deleteContentFromActivePage(data);
		}
	}

	deleteCurrContentPack () {
		const { currContentPack } = Shark.get();

		if (currContentPack) {
			contentPackManager.delete(currContentPack)
			.then(() => {
				Shark.openPage(contentPackListView);
			});
		}
	}

	deleteCurrContentPackBtn_clickHandler () {
		if (confirm("Vuoi davvero cancellare questo Pacchetto di Contenuti?")) {
			this.deleteCurrContentPack();
		}
	}

	ddraggable_dragoverHandler (event) {
		if ((event.dataTransfer.types.includes("image") && event.target.dataset.type === "image") || (event.dataTransfer.types.includes("text/plain") && event.target.dataset.type === "text")) {
			event.preventDefault();
			event.dataTransfer.dropEffect = "move";
			// const bbox = event.target.getBoundingClientRect();
			// const position = bbox.y + bbox.height / 2 > event.clientY ? "beforebegin" : "afterend";
			// console.log(position);
			// event.target.insertAdjacentElement(position, event.target);
		}
	}
	
	ddraggable_dragstartHandler (event) {
		event.dataTransfer.setData(event.target.dataset.type, null);
		event.dataTransfer.setData("text/html", event.target.dataset.guid);
	}
	
	ddraggable_dropHandler (event) {
		const dropData = event.dataTransfer.getData("text/html");
		// const bbox = event.target.getBoundingClientRect();
		// const position = bbox.y + bbox.height / 2 > event.clientY ? "beforebegin" : "afterend";
		// event.target.insertAdjacentElement(position, document.querySelector(`[data-guid="${dropData}"]`));

		const draggedGuid = dropData;
		const swappedGuid = event.target.dataset.guid;
		// console.log({draggedGuid, swappedGuid});
		
		const currPage = contentPackDetailView.getActivePage();

		if (currPage) {
			const targetList = currPage.contents[event.target.dataset.type + "s"];
			const draggedIndex = targetList.findIndex(item => item.guid === draggedGuid);
			const swappedIndex = targetList.findIndex(item => item.guid === swappedGuid);
			
			// console.log(targetList);
			
			targetList[draggedIndex].edited = true;
			targetList[swappedIndex].edited = true;
			
			[targetList[draggedIndex], targetList[swappedIndex]] = [targetList[swappedIndex], targetList[draggedIndex]];
			Shark.render();
		}
	}

	getActivePage () {
		const pageIndex = Shark.$store.activeSecondaryPageIndex;
		let currPage = null;

		if (pageIndex === -1) {
			currPage = Shark.$store.currContentPack.content.mainPage;
		}
		else {
			currPage = Shark.$store.currContentPack.content.secondaryPages[pageIndex];
		}

		return currPage;
	}

	init () {
		this.addComponents([contentFinderComponent, mainNavComponent, waitBoxComponent]);

		Shark.set({
			recentContentList: [],
		});
	}

	async saveCurrContentPack () {
		const shortCodeIsValid = await this.checkShortCode();

		if (shortCodeIsValid) {
			const { currContentPack } = Shark.get();
			
			if (currContentPack) {
				currContentPack.content.mainPage.contents.images.forEach(image => delete image.edited);
				currContentPack.content.mainPage.contents.texts.forEach(text => delete text.edited);
				currContentPack.content.secondaryPages.forEach(page => {
					page.contents.images.forEach(image => delete image.edited);
					page.contents.texts.forEach(text => delete text.edited);
				});
				contentPackManager.save(currContentPack)
				.then(saveResponse => {
					console.log({saveResponse});
					Shark.render();
				});
			}
		}
	}

	saveCurrContentPackBtn_clickHandler () {
		this.saveCurrContentPack();
	}

	// shortCodeField_blurHandler () {
	// 	this.checkShortCode();
	// }
}

const contentPackDetailView = new ContentPackDetailView();

Shark.registerView(contentPackDetailView);

export default contentPackDetailView;
